import React from 'react';

import { Box, Tab, TabList, TabPanel, Tabs, Typography } from '@mui/joy';

import { useSearchParams } from 'react-router-dom';

import { DoorStylesSection } from '../components/DoorStylesSection';

import { NamedEntitySection, useAsyncList } from '../components/NamedEntitySection';

import { ColoursSection } from '../components/ColoursSection';

import { HardwareFinishesSection } from '../components/HardwareFinishesSection';

import { GlassSection } from '../components/GlassSection';

import { HardwareSection } from '../components/HardwareSection';

import { HardwareCollectionsSection } from '../components/HardwareCollectionsSection';

import { CompatibilitySection } from '../components/CompatibilitySection';

import {

  createMaterial,

  createSupplier,

  deleteMaterial,

  deleteSupplier,

  listMaterials,

  listSuppliers,

  materialDependents,

  supplierDependents,

  updateMaterial,

  updateSupplier,

} from '../data/repository';



const TABS = [

  { id: 'door-styles', label: 'Door Styles' },

  { id: 'suppliers', label: 'Suppliers' },

  { id: 'materials', label: 'Materials' },

  { id: 'colours', label: 'Door colours' },

  { id: 'hardware-finishes', label: 'Hardware finishes' },

  { id: 'glass', label: 'Glass' },

  { id: 'hardware', label: 'Hardware' },

  { id: 'hardware-collections', label: 'Hardware Collections' },

  { id: 'compatibility', label: 'Compatibility' },

] as const;



type TabId = (typeof TABS)[number]['id'];



function isTabId(value: string | null): value is TabId {

  return TABS.some((tab) => tab.id === value);

}



export const DoorOraclePage: React.FC = () => {

  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get('tab');

  const tab: TabId = isTabId(tabParam) ? tabParam : 'door-styles';

  const styleId = searchParams.get('style');



  const setTab = (next: TabId, nextStyle?: string | null) => {

    const params = new URLSearchParams();

    params.set('tab', next);

    if (next === 'compatibility' && nextStyle) params.set('style', nextStyle);

    setSearchParams(params);

  };



  return (

    <Box sx={{ p: 3, maxWidth: '1400px', mx: 'auto' }} data-door-oracle-root>

      <Box sx={{ mb: 3 }}>

        <Typography level="h1" sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}>

          Door Oracle

        </Typography>

        <Typography level="body-lg" sx={{ color: 'neutral.500' }}>

          Internal catalogue and compatibility admin. This does not change the public Door Designer.

        </Typography>

      </Box>



      <Tabs value={tab} onChange={(_, value) => setTab((value as TabId) || 'door-styles')}>

        <TabList sx={{ flexWrap: 'wrap' }}>

          {TABS.map((item) => (

            <Tab key={item.id} value={item.id}>

              {item.label}

            </Tab>

          ))}

        </TabList>

        <TabPanel value="door-styles" sx={{ px: 0 }}>

          <DoorStylesSection onOpenCompatibility={(id) => setTab('compatibility', id)} />

        </TabPanel>

        <TabPanel value="suppliers" sx={{ px: 0 }}>

          <SuppliersPanel />

        </TabPanel>

        <TabPanel value="materials" sx={{ px: 0 }}>

          <MaterialsPanel />

        </TabPanel>

        <TabPanel value="colours" sx={{ px: 0 }}>

          <ColoursSection />

        </TabPanel>

        <TabPanel value="hardware-finishes" sx={{ px: 0 }}>

          <HardwareFinishesSection />

        </TabPanel>

        <TabPanel value="glass" sx={{ px: 0 }}>

          <GlassSection />

        </TabPanel>

        <TabPanel value="hardware" sx={{ px: 0 }}>

          <HardwareSection />

        </TabPanel>

        <TabPanel value="hardware-collections" sx={{ px: 0 }}>

          <HardwareCollectionsSection />

        </TabPanel>

        <TabPanel value="compatibility" sx={{ px: 0 }}>

          <CompatibilitySection initialDoorStyleId={styleId} />

        </TabPanel>

      </Tabs>

    </Box>

  );

};



function MaterialsPanel() {

  const list = useAsyncList(listMaterials);

  return (

    <NamedEntitySection

      title="Materials"

      nameLabel="Material name"

      rows={list.rows.map((row) => ({

        id: row.material_id,

        name: row.material_name,

      }))}

      loading={list.loading}

      error={list.error}

      onReload={list.reload}

      onCreate={(input) => createMaterial({ material_name: input.name })}

      onUpdate={(id, input) => updateMaterial(id, { material_name: input.name })}

      onDelete={deleteMaterial}

      dependentsFor={materialDependents}

    />

  );

}



function SuppliersPanel() {

  const list = useAsyncList(listSuppliers);

  return (

    <NamedEntitySection

      title="Suppliers"

      nameLabel="Supplier name"

      rows={list.rows.map((row) => ({

        id: row.supplier_id,

        name: row.supplier_name,

      }))}

      loading={list.loading}

      error={list.error}

      onReload={list.reload}

      onCreate={(input) => createSupplier({ supplier_name: input.name })}

      onUpdate={(id, input) => updateSupplier(id, { supplier_name: input.name })}

      onDelete={deleteSupplier}

      dependentsFor={supplierDependents}

    />

  );

}



export default DoorOraclePage;

